var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCreateOutgoingShipment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "28px",
    viewBox: "0 0 38 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1086.000000, -1045.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41",
    transform: "translate(1087.000000, 1046.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ship-2",
    transform: "translate(18.000000, 9.500000) scale(-1, 1) translate(-18.000000, -9.500000) ",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(6.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.5,
    cy: 16.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 16.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5491943,16.2683105 L29.289917,16.2683105 L29.289917,12.4988029 C29.289917,11.7088194 28.8249081,10.992856 28.1031864,10.6716213 L26.2659308,9.85386799 C25.7212073,9.6114143 25.3702393,9.07103697 25.3702393,8.47479248 C25.3702393,7.84652193 25.1231973,7.24344486 24.6824338,6.79572685 L24.3484819,6.45650581 C23.784583,5.88370945 23.0144122,5.56115723 22.2106226,5.56115723 L19.9736328,5.56115723 L19.9736328,16.0430908",
    id: "Path-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,16.27 L9,16.27",
    id: "Path-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.250488281,5.00012207 L0.250488281,2.97033691 C0.250488281,1.86576741 1.14591878,0.970336914 2.25048828,0.970336914 L14.0458984,0.970336914 C15.1504679,0.970336914 16.0458984,1.86576741 16.0458984,2.97033691 L16.0458984,16.27",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.5 L7.34375,10.5",
    id: "Path-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,7.5 L9.34375,7.5",
    id: "Path-50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(22.500000, 12.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCreateOutgoingShipment);
export default __webpack_public_path__ + "static/media/ico_create_outgoing-shipment.7eaea314a0b5c349b855064c72b1903b.svg";
export { ForwardRef as ReactComponent };